const { Record } = require('immutable')

export default Record({
    value: null,
})
